// 切换分页的时候 滚动到列表的头部
// name 为table的ref绑定值
function toTableTop(name) {
    this.$refs[name].bodyWrapper.scrollTop =0;
}
export {
    toTableTop
}


// WEBPACK FOOTER //
// ./src/util/toTableTop.js